import { create } from 'zustand';

interface UiState {
  branchId: string | null;
  sidebarCollapsed: boolean;
  mobileNavOpen: boolean;
  collapsedGroups: Record<string, boolean>;
  setBranch: (id: string | null) => void;
  toggleSidebar: () => void;
  setMobileNav: (open: boolean) => void;
  toggleGroup: (label: string) => void;
}
export const useUi = create<UiState>((set) => ({
  branchId: null,
  sidebarCollapsed: false,
  mobileNavOpen: false,
  collapsedGroups: {},
  setBranch: (branchId) => set({ branchId }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setMobileNav: (mobileNavOpen) => set({ mobileNavOpen }),
  toggleGroup: (label) =>
    set((s) => ({
      collapsedGroups: {
        ...s.collapsedGroups,
        [label]: !s.collapsedGroups[label],
      },
    })),
}));
